import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M145 285c77.017 0 140-63 140-140S222.017 5 145 5C67.983 5 5 68 5 145s62.9829 140 140 140zm-22.2494-89.4634c-6.6748 3.9268-14.2053.8537-14.2053-5.9756v-89.4634c0-6.6586 8.044-9.561 14.2053-5.8049l73.7654 43.195c5.6478 3.244 5.9901 11.6098 0 14.8538l-73.7654 43.195z"
})), 'PlayFilledIcon');